import Flex from '@deprecated-ui/common/Flex';
import { PopoverTitleWrapper } from '@deprecated-ui/common/Popover';
import { notificationTabsAttrs } from 'utils/notification';
import { useNotificationData } from 'lib/entities/notification/useNotificationData';

import NotificationTitle from './NotificationTitle';
import NotificationTab from './NotificationTab';
import { CloseButton, LineLoader } from './styled';

interface NotificationHeaderProps {
  device?: string;
  // eslint-disable-next-line react/no-unused-prop-types
  close?: () => void;
}

function NotificationHeader({ device }: NotificationHeaderProps) {
  const tab = useNotificationData((store) => store.tab);
  const isLoading = useNotificationData((store) => store.isLoading);

  const closePopup = useNotificationData((store) => store.closePopup);
  const changeTab = useNotificationData((store) => store.changeTab);

  const isMobileDevice = device === 'mobile';

  return (
    <>
      <LineLoader isLoading={isLoading} />
      <PopoverTitleWrapper>
        <Flex align="center" justify="space-between" width="100%">
          <NotificationTitle
            tab={tab}
            onClickBack={() => changeTab('notification')}
          />
        </Flex>
        <Flex>
          {!isMobileDevice && (
            <NotificationTab list={notificationTabsAttrs} type="icon" />
          )}
          {isMobileDevice && (
            <CloseButton onClick={closePopup}>Close</CloseButton>
          )}
        </Flex>
      </PopoverTitleWrapper>
      {isMobileDevice && (
        <Flex align="center" justify="center">
          <NotificationTab list={notificationTabsAttrs} type="text" />
        </Flex>
      )}
    </>
  );
}

export default NotificationHeader;
